__turbopack_context__.v({
  "root": "index-module__qFtRXq__root",
});
